"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterPriceOptionsBuyUsd = exports.defaultSfilterPriceOptionsBuyHkd = exports.defaultSfilterPriceOptionsRentUsd = exports.defaultSfilterPriceOptionsRentHkd = void 0;
exports.defaultSfilterPriceOptionsRentHkd = [
    { from: 0, to: 25000, name: 'Below 25K' },
    { from: 25000, to: 40000, name: '25 - 40K' },
    { from: 40000, to: 60000, name: '40 - 60K' },
    { from: 60000, to: 80000, name: '60 - 80K' },
    { from: 80000, to: 100000, name: '80 - 100K' },
    { from: 100000, to: -1, name: 'Above 100K' },
];
exports.defaultSfilterPriceOptionsRentUsd = [
    { from: 0, to: 3000, name: 'Below 3K' },
    { from: 3000, to: 4000, name: '3 - 4K' },
    { from: 4000, to: 6000, name: '4 - 6K' },
    { from: 6000, to: 8000, name: '6 - 8K' },
    { from: 8000, to: 10000, name: '8 - 10K' },
    { from: 10000, to: -1, name: 'Above 10K' },
];
exports.defaultSfilterPriceOptionsBuyHkd = [
    { from: 0, to: 8000000, name: 'Below 8M' },
    { from: 8000000, to: 12000000, name: '8 - 12M' },
    { from: 12000000, to: 16000000, name: '12 - 16M' },
    { from: 16000000, to: 20000000, name: '16 - 20M' },
    { from: 20000000, to: -1, name: 'Above 20M' },
];
exports.defaultSfilterPriceOptionsBuyUsd = [
    { from: 0, to: 800000, name: 'Below 800K' },
    { from: 800000, to: 1200000, name: '800 - 1.2M' },
    { from: 1200000, to: 1600000, name: '1.2 - 1.6M' },
    { from: 1600000, to: 2000000, name: '1.6 - 2M' },
    { from: 2000000, to: -1, name: 'Above 2M' },
];
